import { graphql, useStaticQuery } from 'gatsby';

export const helpPageQuery = () => {
  const data = useStaticQuery(graphql`
    query {
      pageContentJson {
        help{
            categories {
                title
                description
                slug
            }
          topics {
            question
            answer
            category
          }
        }
      }
    }
  `);
  const topics = data.pageContentJson.help;

  return { 
    topics
   }

};
